export class Shop {
  shopId?: number
  name: string = ''
  description: string = ''
  imageUrl: string = ''
  url: string = ''
  specifiedCommercialTransactionsUrl: string = ''
}
